import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Thunderstorm is a full web app framework!
 *
 * Typescript & Express backend infrastructure that natively runs on firebase function
 * Typescript & React frontend infrastructure
 *
 * Copyright (C) 2020 Adam van der Kruk aka TacB0sS
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import * as React from 'react';
import { EntryComponentLoadingModule } from './entry-component-loading-module.js';
export class ReactEntryComponentInjector extends React.Component {
    myRef = React.createRef();
    constructor(props) {
        super(props);
        this.state = { loading: false, progress: 0 };
    }
    __onRequestCompleted = (key, success) => {
        if (key !== this.props.src)
            return;
        if (!success)
            // Need to add error handling here...
            return;
        this.injectComponent(EntryComponentLoadingModule.getNode(key));
    };
    injectComponent(node) {
        this.myRef.current?.appendChild(node);
        this.setState({ loading: false });
    }
    componentDidMount() {
        const src = this.props.src;
        const node = EntryComponentLoadingModule.getNode(src);
        if (node)
            return this.injectComponent(node);
        EntryComponentLoadingModule.loadScript(src, (progress) => this.setState({ progress }));
        this.setState({ loading: true });
    }
    render() {
        return _jsx("div", { ref: this.myRef, id: this.props.src, children: this.extracted() });
    }
    extracted() {
        const Loader = this.props.loader;
        if (Loader)
            return _jsx(Loader, { progress: this.state.progress });
        return _jsxs("div", { style: { width: '100%', height: '100%' }, children: [this.state.progress, " %"] });
    }
}
//# sourceMappingURL=ReactEntryComponentInjector.js.map